// TODO: Move into `./common/environment`
// TODO: Add all environment variables here & update references

import type { CommonEnvironment } from '~/contracts/common';

function invariant(condition: any, message: string): asserts condition {
  if (!condition) throw new Error(message);
}

invariant(process.env.APP_VERSION, 'APP_VERSION must be set');
invariant(process.env.DEPLOY_ENV, 'DEPLOY_ENV must be set');
invariant(
  ['dev', 'test', 'prod'].includes(process.env.DEPLOY_ENV),
  'DEPLOY_ENV must be dev, test, or prod'
);
invariant(
  process.env.CVNA_APP_ABSOLUTE_BASE_URL,
  'CVNA_APP_ABSOLUTE_BASE_URL must be set'
);
invariant(process.env.CVNA_APIK_BASE_URL, 'CVNA_APIK_BASE_URL must be set');
invariant(process.env.CVNA_APP_CDN_URL, 'CVNA_APP_CDN_URL must be set');
invariant(
  process.env.CVNA_APP_CDNBLOB_BASE_URL,
  'CVNA_APP_CDNBLOB_BASE_URL must be set'
);
invariant(
  process.env.CVNA_APP_CDNSTATIC_BASE_URL,
  'CVNA_APP_CDNSTATIC_BASE_URL must be set'
);
invariant(
  process.env.CVNA_APP_CDN_SHAREABLE_PATH,
  'CVNA_APP_CDN_SHAREABLE_PATH must be set'
);
invariant(
  process.env.CVNA_APP_GOOGLE_MAPS_JS_API_KEY,
  'CVNA_APP_GOOGLE_MAPS_JS_API_KEY must be set'
);
invariant(process.env.CVNA_APP_GTM_ID, 'CVNA_APP_GTM_ID must be set');
invariant(
  process.env.CVNA_APP_DEALERSHIP_GTM_ID,
  'CVNA_APP_DEALERSHIP_GTM_ID must be set'
);
invariant(
  process.env.CVNA_APP_SHIFTDIGITAL_GTM_ID,
  'CVNA_APP_SHIFTDIGITAL_GTM_ID must be set'
);
invariant(
  process.env.CVNA_APP_SHIFTDIGITAL_ATM_ID,
  'CVNA_APP_SHIFTDIGITAL_ATM_ID must be set'
);

export const appVersion = process.env.APP_VERSION;

export const environment = process.env.DEPLOY_ENV;

export const isLocalEnvironment = Boolean(process.env.IS_LOCAL);

export const isProd = environment === 'prod';

export const isTest = environment === 'test';

export const isNonProd = environment === 'dev' || environment === 'test';

const commonEnvironmentMapping: Record<string, CommonEnvironment> = {
  dev: 'development',
  test: 'test',
  prod: 'production'
};

export const commonEnvironment = commonEnvironmentMapping[environment];

export const absoluteBaseUrl: string = isLocalEnvironment
  ? 'https://localhost.carvana.com'
  : process.env.CVNA_APP_ABSOLUTE_BASE_URL;

export const apikUrl = process.env.CVNA_APIK_BASE_URL;

export const assetsCdnUrl = process.env.CVNA_APP_CDN_URL;

export const appAssetsCdnUrl = isLocalEnvironment
  ? '/public'
  : `${assetsCdnUrl}/merchui`;

export const blobCdnUrl = process.env.CVNA_APP_CDNBLOB_BASE_URL;

export const staticCdnUrl = process.env.CVNA_APP_CDNSTATIC_BASE_URL;

export const shareableCdnPath = process.env.CVNA_APP_CDN_SHAREABLE_PATH;

export const vexCdnUrl = 'https://vexgateway.fastly.carvana.io';

export const spinnerDataUrl = process.env.CVNA_APP_SPINNER_DATA_URL;

export const vexBlobUrl = process.env.CVNA_APP_VEXBLOB_BASE_URL;

export const vexStockImages =
  'https://vexstockimages.fastly.carvana.io/stockimages';

export const googleMapsApiKey = process.env.CVNA_APP_GOOGLE_MAPS_JS_API_KEY;

export const googleMapsMapId = process.env.CVNA_APP_GOOGLE_MAPS_MAP_ID;

export const hygraphApiKey = process.env.HYGRAPH_API_KEY;

export const autoCheckPassword = process.env.AUTOCHECK_PASSWORD;

export const carvanaGoogleTagManagerId = process.env.CVNA_APP_GTM_ID;

export const dealershipGoogleTagManagerId =
  process.env.CVNA_APP_DEALERSHIP_GTM_ID;

export const shiftDigitalGoogleTagManagerId =
  process.env.CVNA_APP_SHIFTDIGITAL_GTM_ID;

export const shiftDigitalAdobeTagManagerId =
  process.env.CVNA_APP_DEALERSHIP_ATM_ID;

export const cubeApiUrl =
  process.env.NEXT_PUBLIC_TDC_API_URL ||
  'https://tdc-cube-production.up.railway.app';

export const complianceDsarPageUrl = process.env.CVNA_APP_COMPLIANCE_DSAR_PAGE;
